import { FileUpIcon } from 'lucide-react'
import { HTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'

type Props = {
  isDragActive: boolean
  message?: string
} & HTMLAttributes<HTMLDivElement>

const DropzoneOverlay = ({ isDragActive, message, ...props }: Props) => {
  const { t } = useTranslation()

  return (
    <div
      {...props}
      className={cn(
        'pointer-events-none absolute inset-0 flex justify-center items-center transition-all',
        {
          'bg-background/30 backdrop-blur-md z-20': isDragActive,
        },
        props.className,
      )}
    >
      <div
        className={cn(
          'items-center gap-4 p-8 bg-background border-2 border-primary rounded-lg flex pointer-events-none transition-all',
          {
            'opacity-0 translate-y-5': !isDragActive,
            'opacity-100 translate-y-0': isDragActive,
          },
        )}
      >
        <FileUpIcon className="size-8 text-text-primary" />
        <p className="text-xl text-text-primary font-medium">
          {message ?? t('dropzone.dropFilesHere')}
        </p>
      </div>
    </div>
  )
}

export { DropzoneOverlay }
